import { call } from 'vuex-pathify';
import { GeoJSON } from 'ol/format';
export default {
  methods: {
    getLayerFeature: call('layers/getLayerFeature'),
    async toggleSplitingLineHalf() {
      this.isSplittingLineButtonLoading = true;
      try {
        let featureGeometry = (
          await this.getLayerFeature({ layer_id: this.layerId, feature_id: this.selectedFeatureId })
        )?.geometry;
        if (featureGeometry?.type !== 'LineString' && featureGeometry?.coordinates?.length > 1) {
          this.$store.set('snackbar/PUSH_ERROR!', {
            message: this.$i18n.t('errors.lineMustHaveOnePartToSplit'),
          });
          this.isSplittingLineButtonLoading = false;
          return;
        } else if (featureGeometry?.type !== 'LineString' && featureGeometry?.coordinates?.length === 1) {
          featureGeometry = { type: 'LineString', coordinates: featureGeometry.coordinates[0] };
        }
        const olGeometry = new GeoJSON().readGeometry(featureGeometry, {
          dataProjection: this.$_config.defaultEpsg,
          featureProjection: this.$_config.defaultEpsg,
        });
        const midPointGeometry = {
          crs: {
            properties: {
              name: this.$_config.defaultEpsg,
            },
            type: 'name',
          },
          coordinates: olGeometry.getCoordinateAt(0.5),
          type: 'Point',
        };
        this.openSplitLineHalfConfirmationDialog({
          midPointGeometry,
        });
        this.isSplittingLineButtonLoading = false;
      } catch {
        this.isSplittingLineButtonLoading = false;
      }
    },
    openSplitLineHalfConfirmationDialog({ midPointGeometry } = {}) {
      this.splitGeometry = midPointGeometry;
      this.openDialog('split');
    },
  },
};
